/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Hex from 'solis/type/hex';


class Transform
{
  constructor (offset, rotation)
  {
    this.offset = offset;
    this.rotation = rotation;
  }


  equals (other)
  {
    return other !== null && this.offset.equals(other.offset) && this.rotation === other.rotation;
  }


  toJSON ()
  {
    return { offset: this.offset.toString(), rotation: this.rotation };
  }
}


export const makeTransform = (offset, rotation) =>
{
  return new Transform(offset || new Hex(0, 0), rotation || 0);
}


export const makeEmptyTransform = () =>
{
  return makeTransform(new Hex(0, 0), 0);
}
